export const ADMIN_HOST = process.env.REACT_APP_ADMIN_HOST || "admin.betbond.app";
export const MAIN_SITE_HOST = process.env.REACT_APP_MAIN_HOST || "betbond.app";

export const isLocalDevHost = () => {
  if (typeof window === "undefined") return false;
  const hostname = window.location.hostname;
  return (
    process.env.NODE_ENV === "development" &&
    (hostname === "localhost" || hostname === "127.0.0.1")
  );
};

export const isAdminPath = (pathname = "/") => {
  const path = String(pathname || "/");
  return path === "/login" || path === "/admin" || path.startsWith("/admin/");
};

export const isAdminHost = () =>
  typeof window !== "undefined" && window.location.hostname === ADMIN_HOST;

/** True when the app should render admin portal routes (dedicated host or local /admin paths). */
export const shouldUseAdminRoutes = (pathname = "/") =>
  isAdminHost() || (isLocalDevHost() && isAdminPath(pathname));

const withLocalDevPort = (host, path) => {
  const normalized = path.startsWith("/") ? path : `/${path}`;

  if (typeof window === "undefined") {
    return `https://${host}${normalized}`;
  }

  const { protocol, port, hostname } = window.location;
  const onLocalDevHost =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === ADMIN_HOST ||
    hostname === MAIN_SITE_HOST;
  const hasDevPort = Boolean(port) && port !== "80" && port !== "443";

  if (onLocalDevHost && hasDevPort) {
    return `${protocol}//${host}:${port}${normalized}`;
  }

  return `https://${host}${normalized}`;
};

/** Absolute URL for the admin portal (admin.betbond.app). Keeps local :port when developing. */
export const getAdminPortalUrl = (path = "/admin") =>
  withLocalDevPort(ADMIN_HOST, path);

/** Absolute URL for the public site (betbond.app). */
export const getMainSiteUrl = (path = "/") =>
  withLocalDevPort(MAIN_SITE_HOST, path);
